import React from 'react'
import MaterialSymbol from '../material-symbol'

const PlayArrow = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="play_arrow" {...props} />
))

PlayArrow.displayName = 'PlayArrow'

export default PlayArrow
